import { Grid } from '@mui/material'
import React from 'react'
import {Link} from 'react-router-dom'

export default function Collection() {
  return (
    <>
    <section className='py-10'>
        <div className='container mx-auto px-4'>
            <Grid container spacing={3}>
                <Grid item lg={6}>
                    <div className='relative overflow-hidden'>
                        <img src='assets/images/banner-1.jpg' className='h-96 w-full object-cover'/>
                        <div className='text-center absolute top-[50%] translate-y-[-50%] mx-auto left-0 right-0'>
                            <h2 className='headningfont text-4xl mb-2 text-white uppercase'>Summer Collections</h2>
                            <h3 className='mb-6 text-white'>Freshwater pearl necklace and earrings</h3>
                            <Link to="" className="inline-block py-3 px-8 border-2 uppercase tracking-[2px]  text-xs border-white text-white hover:bg-white hover:text-black transition-all">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </Grid>
                <Grid item lg={6}>
                <div className='relative overflow-hidden'>
                        <img src='assets/images/banner-2.jpg' className='h-96 w-full object-cover'/>
                        <div className='text-center absolute top-[50%] translate-y-[-50%] mx-auto left-0 right-0'>
                            <h2 className='headningfont text-4xl mb-2 text-white uppercase '>Summer Collections</h2>
                            <h3 className='mb-6 text-white'>Freshwater pearl necklace and earrings</h3>
                            <Link to="" className="inline-block py-3 px-8 border-2 uppercase tracking-[2px]  text-xs border-white text-white hover:bg-white hover:text-black transition-all">Explore <i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    </section>
    </>
  )
}
